import { Skeleton } from '@mui/material';
import React from 'react';
import { cn, extractNumericValue } from '../../../../utils';

const Initial = ({
  label,
  height = 'h-[28px]',
  width = 'w-[28px]',
  initialTextSize,
  className,
}) => {
  initialTextSize = initialTextSize
    ? initialTextSize
    : extractNumericValue(width) > 16
      ? 'text-[16px]'
      : 'text-[12px]';
  return (
    <>
      {label ? (
        <div
          className={cn(
            'relative flex items-center justify-center rounded-full bg-primary text-[16px] font-bold uppercase text-white',
            height,
            width,
            initialTextSize,
            className
          )}
        >
          {label.charAt(0)}
        </div>
      ) : (
        <Skeleton variant='circular' className={`${height} ${width}`} />
      )}
    </>
  );
};

export default Initial;
